module.exports = __webpack_public_path__ + "img/bg_icon.4040c829.png";